// extracted by mini-css-extract-plugin
export default {"melodyVideo":"MU-z","isFullWidth":"NU-z","landingPageVideo":"OU-z","play":"PU-z","iframeVideo":"QU-z","playHidden":"RU-z","fullwidth":"SU-z"};